<script setup>
import {Spin} from "ant-design-vue";
</script>

<template>
  <a-spin/>
</template>
